import { Flex, Heading, Text, Image, Box } from '@everlywell/ui-kit';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { ImageType } from 'utils/types';

export type InLineCardProps = {
  title: string;
  desktopImage?: ImageType | null;
  mobileImage?: ImageType | null;
  description: string;
};

/**
 * InLineCard component
 * @param {InLineCardProps} props - The props of the component
 * @returns {JSX.Element} - The component
 */
const InLineCard = ({
  title,
  description,
  mobileImage,
  desktopImage,
}: InLineCardProps): JSX.Element => (
  <Flex
    backgroundColor="tints.cream"
    borderRadius="xl"
    justifyContent="space-between"
    alignItems="center"
    gap="4"
    minHeight="100px"
    paddingX="4"
    paddingY="3"
  >
    <Flex flexDirection="column" justifyContent="center">
      <Heading as="h3" marginBottom="3" size="sm">
        {title}
      </Heading>
      <Text fontSize="md" color="tints.uiGrey">
        {description}
      </Text>
    </Flex>

    {/* Mobile Image */}
    <Box
      display={['block', null, 'none']}
      height="80px"
      width="80px"
      data-testid="card-mobile-image"
    >
      <Image
        as={GatsbyImage}
        image={mobileImage?.gatsbyImageData}
        margin="0 auto"
        alt={mobileImage?.description || ''}
        height="inherit"
        width="inherit"
      />
    </Box>

    {/* Desktop Image */}
    <Box
      display={['none', null, 'block']}
      height="80px"
      width="80px"
      data-testid="card-desktop-image"
    >
      <Image
        as={GatsbyImage}
        image={desktopImage?.gatsbyImageData}
        margin="0 auto"
        alt={desktopImage?.description || ''}
        height="inherit"
        width="inherit"
      />
    </Box>
  </Flex>
);

export default InLineCard;
